import { gql } from "__generated__/gql";

export const CURRENT_BRAND_FIELDS = gql(/* GraphQL */ `
  fragment CurrentBrandFields on Brand {
    id
    name
    metadata
    isSubscriptionValid
    isParent
    parentId
    layout
    pitchableAccount {
      brandId
    }
    accessPlan {
      id
      planType
      ...QuotaLimitsAccessPlan
    }
    modules
  }
`);

export const CURRENT_BRAND = gql(/* GraphQL */ `
  query CurrentBrand($brandId: UUID!) {
    brand(id: $brandId) {
      ...CurrentBrandFields
    }
  }
`);

export const CURRENT_USER_FIELDS = gql(/* GraphQL */ `
  fragment CurrentUserFields on User {
    id
    firstName
    lastName
    email
    metadata
    isActive
    isStaff
    isSuperuser
    isDataEntryRole
    lastLogin
    createdAt
    features
    ...NavBarAccountMenuUser
  }
`);

export const FETCH_CURRENT_USER = gql(/* GraphQL */ `
  query FetchCurrentUser($brandId: UUID!, $hasBrandId: Boolean = false) {
    requestId(scope: "FetchCurrentUser")
    me {
      ...CurrentUserFields
      brands(first: 1, orderBy: CREATED_AT_ASC) {
        totalCount
        nodes {
          id
          ...CurrentBrandFields
        }
      }
      brokersList(orderBy: NAME_ASC) {
        id
        name
        slug
        ...BrokerAccountMenuItem
        ...BrokerAdminNavCurrentBroker
      }
    }
    brands {
      totalCount
    }
    brand(id: $brandId) @include(if: $hasBrandId) {
      ...CurrentBrandFields
    }
    activeAppAlertsList {
      id
      heading
      body
      status
      placement
    }
  }
`);

export const RECORD_BRAND_ACCOUNT_ACCESS = gql(/* GraphQL */ `
  mutation RecordBrandAccountAccess($brandId: UUID!, $userId: UUID!) {
    createBrandAccountAccess(
      input: { brandAccountAccess: { brandId: $brandId, userId: $userId } }
    ) {
      brandAccountAccess {
        id
      }
    }
  }
`);
